import { useState, useEffect } from "react";
import Sidebar from '../../../componente/sidebar/index.jsx';
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import PopUpPedidoItens from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function OpePedido() {
    const { DateTime } = require("luxon");
    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [codpedido, setCodPedido] = useState(0);
    const [numpedido, setNumPedido] = useState(0);
    const [dtlancamento, setDtLancamento] = useState("");
    const [dtpedido, setDtPedido] = useState("");
    const [dtconclusao, setDtConclusao] = useState("");
    const [dtprevisaoconclusao, setDtPrevisaoConclusao] = useState("");
    const [cliente, setCliente] = useState("");
    const [observacao, setObservacao] = useState("");

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [isOpenPedidoItens, setIsOpenPedidoItens] = useState(false);

    const { user, selectedCompany, accessKey } = useAppContext(); // Acessa os dados do contexto

    const [codproduto, setCodProduto] = useState(0);
    const [codpedidoitens, setCodPedidoItens] = useState(0);
    const [listaProduto, setListaProduto] = useState([]);
    const [listaPedidoItens, setListaPedidoItens] = useState([]);

    // Função para calcular o primeiro dia do mês
    const getFirstDayOfMonth = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-01`;
    };

    // Função para calcular a data atual
    const getCurrentDate = () => {
        const dt = new Date();
        return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, "0")}-${dt.getDate().toString().padStart(2, "0")}`;
    };

    const [startDate, setStartDate] = useState(getFirstDayOfMonth);
    const [endDate, setEndDate] = useState(getCurrentDate);

    const [codtecido, setCodTecido] = useState(0);
    const [listaTecido, setListaTecido] = useState([]);
    const [codcor, setCodCor] = useState(0);
    const [listaCor, setListaCor] = useState([]);
    const [codtamanho, setCodTamanho] = useState(0);
    const [listaTamanho, setListaTamanho] = useState([]);

    const handleOpen = (cad) => {
        setCodPedido(cad.codpedido);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        Excluir();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    const handleOpenPedidoItens = (cad) => {
        setCodPedidoItens(cad.codpedidoitens);
        setIsOpenPedidoItens(true);
    };

    const handleConfirmaPedidoItens = () => {
        setIsOpenPedidoItens(false);
        ExcluirPedidoItens();
    };

    const handleClosePedidoItens = () => {
        setIsOpenPedidoItens(false);
    };

    function ListarTecido() {
        api
            .get("v1/cadastro/produto/tecido", {
                params: {
                    codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaTecido(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarCor() {
        api
            .get("v1/cadastro/produto/cor", {
                params: {
                    codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaCor(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarTamanho() {
        api
            .get("v1/cadastro/produto/tamanho", {
                params: {
                    codproduto
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaTamanho(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarTamanho();
            ListarCor();
            ListarTecido();
        },
        [codproduto]
    );

    function ListarProduto() {
        api
            .get("/v1/operacoes/pedido/pedidoitens/produto", {
                params: {
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaProduto(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarPedidoItens(cad) {
        api
            .get("/v1/operacoes/pedido/pedidoitens", {
                params: {
                    codpedido: cad.codpedido
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setListaPedidoItens(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ListarPedido() {
        api
            .get("/v1/operacoes/pedido", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1: startDate,
                    dt2: endDate
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarPedido();
        },
        [abusca, selectedCompany, startDate, endDate]
    );

    function Cadastrar() {
        const dt1 = new Date();
        const date1 =
            dt1.getFullYear() +
            "-" +
            (dt1.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt1.getDate().toString().padStart(2, "0");
        let time1 =
            dt1.getHours().toString().padStart(2, "0") +
            ":" +
            dt1.getMinutes().toString().padStart(2, "0");
        let dtcadastro1 = date1 + "T" + time1;

        setDtLancamento(dtcadastro1);

        api
            .post(
                "/v1/operacoes/pedido",
                {
                    numpedido,
                    dtlancamento,
                    dtpedido,
                    dtconclusao,
                    dtprevisaoconclusao,
                    cliente,
                    observacao,
                    excluido: "N",
                    codempresa: selectedCompany,
                    codusuario: user.codusuario,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarPedido();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function CadastrarProduto() {
        if (codtamanho === 0 || codtecido === 0 || codcor === 0) {
            alert("Selecione o tamanho, o tecido e a cor");
        } else {
            if (novo) {
                const dt1 = new Date();
                const date1 =
                    dt1.getFullYear() +
                    "-" +
                    (dt1.getMonth() + 1).toString().padStart(2, "0") +
                    "-" +
                    dt1.getDate().toString().padStart(2, "0");
                let time1 =
                    dt1.getHours().toString().padStart(2, "0") +
                    ":" +
                    dt1.getMinutes().toString().padStart(2, "0");
                let dtcadastro1 = date1 + "T" + time1;

                setDtLancamento(dtcadastro1);

                api
                    .post(
                        "/v1/operacoes/pedido",
                        {
                            numpedido,
                            dtlancamento,
                            dtpedido,
                            dtconclusao,
                            dtprevisaoconclusao,
                            cliente,
                            observacao,
                            excluido: "N",
                            codempresa: selectedCompany,
                            codusuario: user.codusuario,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },
                        }
                    )
                    .then(function (response) {
                        setnovo(false);
                        setCodPedido(response.data.codpedido);

                        api
                            .post(
                                "/v1/operacoes/pedido/pedidoitens",
                                {
                                    codpedido: response.data.codpedido,
                                    codproduto,
                                    codtamanho,
                                    codtecido,
                                    codcor,
                                    excluido: "N",
                                },
                                {
                                    headers: {
                                        Authorization: `Bearer ${accessKey}`,
                                    },
                                }
                            )
                            .then(() => {
                                ListarPedidoItens();
                            })
                            .catch(function (err) {
                                console.log("ops! ocorreu um erro: " + err);
                            });
                    })
                    .catch(function (err) {
                        console.log("ops! ocorreu um erro: " + err);
                    });
            } else {
                api
                    .post(
                        "/v1/operacoes/pedido/pedidoitens",
                        {
                            codpedido,
                            codproduto,
                            codtamanho,
                            codtecido,
                            codcor,
                            excluido: "N",
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${accessKey}`,
                            },
                        }
                    )
                    .then(() => {
                        ListarPedidoItens();
                    })
                    .catch(function (err) {
                        console.log("ops! ocorreu um erro: " + err);
                    });
            }
        }
    }

    function Editar() {
        api
            .put(
                "v/v1/operacoes/pedido",
                {
                    numpedido,
                    dtpedido,
                    dtconclusao,
                    dtprevisaoconclusao,
                    cliente,
                    observacao,
                    codpedido
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarPedido();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("/v1/operacoes/pedido", {
                params: {
                    codpedido,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarPedido();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function ExcluirPedidoItens() {
        api
            .delete("/v1/operacoes/pedido/pedidoitens", {
                params: {
                    codpedidoitens,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarPedidoItens();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setCodPedido(0);
        setNumPedido(0);

        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let dtcadastro = date;

        setDtPedido(dtcadastro);

        const dt1 = new Date();
        const date1 =
            dt1.getFullYear() +
            "-" +
            (dt1.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt1.getDate().toString().padStart(2, "0");
        let time1 =
            dt1.getHours().toString().padStart(2, "0") +
            ":" +
            dt1.getMinutes().toString().padStart(2, "0");
        let dtcadastro1 = date1 + "T" + time1;

        setDtConclusao(dtcadastro1);
        setDtPrevisaoConclusao(dtcadastro1);
        setCliente("");
        setObservacao("");

        ListarProduto();
    }

    function openModalEditar(cad) {
        setshowform(true);
        setnovo(false);

        setCodPedido(cad.codpedido);
        setNumPedido(cad.numpedido);

        const dt = DateTime.fromISO(cad.dtpedido)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd");

        setDtPedido(dt);

        const dt1 = DateTime.fromISO(cad.dtconclusao)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd HH:mm");

        setDtConclusao(dt1);

        const dt2 = DateTime.fromISO(cad.dtprevisaoconclusao)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd HH:mm");

        setDtPrevisaoConclusao(dt2);


        setCliente(cad.cliente);
        setObservacao(cad.observacao);

        ListarProduto();
        ListarPedidoItens(cad);
    }

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    function FormataData(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : null;
    }

    return (
        <>
            <div className="app-container">
                <Sidebar />
                <div className="content-container">
                    <div className="container-fluid">
                        <div>
                            <div>
                                <PopUp isOpen={isOpen} onClose={handleClose}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse registro?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirma}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleClose}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUp>

                                <PopUpPedidoItens isOpen={isOpenPedidoItens} onClose={handleClosePedidoItens}>
                                    <h2>Verificação</h2>
                                    <p>Tem certeza que deseja excluir esse item?</p>

                                    <div className="row">
                                        <div className="col-12 mt-3 d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary me-2"
                                                onClick={handleConfirmaPedidoItens}
                                            >
                                                Sim
                                            </button>
                                            <button type="button" className="btn btn-danger" onClick={handleClosePedidoItens}>
                                                Não
                                            </button>
                                        </div>
                                    </div>
                                </PopUpPedidoItens>
                            </div>

                            <Modal
                                isOpen={showform}
                                onRequestClose={closeModal}
                                overlayClassName="modal-overlay"
                                className="modal-content modal-xl"
                            >
                                <div className="container-fluid h-100">
                                    <div className="modal-header">
                                        {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
                                        <button type="button" className="btn-close" onClick={closeModal}></button>
                                    </div>

                                    <div className="modal-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                                    <label htmlFor="numpedido" className="form-label">
                                                        Núm. Pedido
                                                    </label>
                                                    <input
                                                        type="number"
                                                        id="numpedido"
                                                        className="form-control"
                                                        placeholder="Núm. Pedido"
                                                        value={numpedido}
                                                        onChange={(e) => setNumPedido(e.target.valueAsNumber)}
                                                    />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                                    <label htmlFor="dtpedido" className="form-label">
                                                        Dt. Pedido
                                                    </label>
                                                    <input
                                                        type="date"
                                                        id="dtpedido"
                                                        className="form-control"
                                                        placeholder="Dt. Pedido"
                                                        value={dtpedido}
                                                        onChange={(e) => setDtPedido(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                                    <label htmlFor="dtconclusao" className="form-label">
                                                        Dt. Conclusão
                                                    </label>
                                                    <input
                                                        type="datetime-local"
                                                        id="dtconclusao"
                                                        className="form-control"
                                                        placeholder="Dt. Conclusão"
                                                        value={dtconclusao}
                                                        onChange={(e) => setDtConclusao(e.target.value)}
                                                    />
                                                </div>

                                                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12">
                                                    <label htmlFor="dtprevisaoconclusao" className="form-label">
                                                        Dt. Previsão Conclusão
                                                    </label>
                                                    <input
                                                        type="datetime-local"
                                                        id="dtprevisaoconclusao"
                                                        className="form-control"
                                                        placeholder="Dt. Previsão Conclusão"
                                                        value={dtprevisaoconclusao}
                                                        onChange={(e) => setDtPrevisaoConclusao(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <label htmlFor="cliente" className="form-label">
                                                        Cliente
                                                    </label>
                                                    <input
                                                        type="text"
                                                        id="cliente"
                                                        className="form-control"
                                                        placeholder="Cliente"
                                                        value={cliente}
                                                        onChange={(e) => setCliente(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                    <label htmlFor="observacao" className="form-label">
                                                        Observação
                                                    </label>
                                                    <textarea
                                                        id="observacao"
                                                        className="form-control"
                                                        placeholder="Digite sua observação"
                                                        value={observacao}
                                                        onChange={(e) => setObservacao(e.target.value)}
                                                        rows={3}
                                                    />
                                                </div>
                                            </div>

                                            <div><hr /></div>

                                            <div className="row">
                                                <div className="col-xl-10 col-lg-8 col-md-8 col-sm-12">
                                                    <label htmlFor="produto" className="form-label">
                                                        Produto
                                                    </label>
                                                    <select
                                                        id="produto"
                                                        className="form-select"
                                                        value={codproduto}
                                                        onChange={(e) => setCodProduto(e.target.value)}
                                                    >
                                                        <option value="0">Escolha o produto</option>
                                                        {listaProduto.map(function (pro) {
                                                            return (
                                                                <option
                                                                    key={pro.codproduto}
                                                                    value={pro.codproduto}
                                                                >
                                                                    {pro.modelo} - {pro.tamanho} - {pro.tecido} - {pro.cor}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btnnovo"
                                                        onClick={() => CadastrarProduto()}
                                                    >
                                                        Adicionar
                                                    </button>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                                    <label htmlFor="tamanho" className="form-label">
                                                        Tamanho
                                                    </label>
                                                    <select
                                                        id="tamanho"
                                                        className="form-select"
                                                        value={codtamanho}
                                                        onChange={(e) => setCodTamanho(e.target.value)}
                                                    >
                                                        <option value="0">Escolha o tamanho</option>
                                                        {listaTamanho.map(function (tam) {
                                                            return (
                                                                <option
                                                                    key={tam.codtamanho}
                                                                    value={tam.codtamanho}
                                                                >
                                                                    {tam.descricao}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                                    <label htmlFor="tecido" className="form-label">
                                                        Tecido
                                                    </label>
                                                    <select
                                                        id="tecido"
                                                        className="form-select"
                                                        value={codtecido}
                                                        onChange={(e) => setCodTecido(e.target.value)}
                                                    >
                                                        <option value="0">Escolha o tecido</option>
                                                        {listaTecido.map(function (tec) {
                                                            return (
                                                                <option
                                                                    key={tec.codtecido}
                                                                    value={tec.codtecido}
                                                                >
                                                                    {tec.descricao}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>

                                                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12">
                                                    <label htmlFor="cor" className="form-label">
                                                        Cor
                                                    </label>
                                                    <select
                                                        id="cor"
                                                        className="form-select"
                                                        value={codcor}
                                                        onChange={(e) => setCodCor(e.target.value)}
                                                    >
                                                        <option value="0">Escolha a cor</option>
                                                        {listaCor.map(function (c) {
                                                            return (
                                                                <option
                                                                    key={c.codcor}
                                                                    value={c.codcor}
                                                                >
                                                                    {c.descricao}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row tabela">
                                                <table className="table table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Produto</th>
                                                            <th className="acao">Ações</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {listaPedidoItens.map(function (item, index) {
                                                            return (
                                                                <tr key={index}>
                                                                    <th>{item.produto}</th>
                                                                    <th>
                                                                        <div className="d-flex justify-content-center">
                                                                            <button
                                                                                type="button"
                                                                                className="btn fa-solid fa-trash"
                                                                                onClick={() => handleOpenPedidoItens(item)}
                                                                            ></button>
                                                                        </div>
                                                                    </th>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={2}>Quantidade de Registros: {listaPedidoItens.length}</th>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </form>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-danger" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button type="button" className="btn btn-success" onClick={Salvar}>
                                            Salvar
                                        </button>

                                    </div>
                                </div>
                            </Modal>
                        </div>

                        <div className="row">
                            <h1 className="ms-4">Cadastro de Pedido</h1>
                            <p className="ms-4">Rotina para cadastrar os pedidos para fabricação</p>
                            <hr />
                        </div>

                        <div className="row">
                            <div className="col-xl-6 col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label" htmlFor="busca">
                                    Busque aqui
                                </label>
                                <input
                                    type="text"
                                    placeholder="Buscar por: Núm. Pedido ou Cliente"
                                    name="busca"
                                    id="busca"
                                    className="form-control"
                                    value={abusca}
                                    onChange={(e) => setabusca(e.target.value)}
                                />
                            </div>

                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
                                <label className="form-label">
                                    Início:
                                </label>
                                <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                            </div>

                            <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12">
                                <label className="form-label">
                                    Fim:
                                </label>
                                <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                            </div>

                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center">
                                <button
                                    type="button"
                                    className="btn btn-success btnnovo"
                                    onClick={() => openModalNovo()}
                                >
                                    Novo
                                </button>
                            </div>
                        </div>

                        <div className="row mt-3">
                            <hr />
                        </div>

                        <div className="row tabela">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Núm. Pedido</th>
                                        <th>Dt. Pedido</th>
                                        <th>Dt. Conclusão</th>
                                        <th>Dt. Prev. Conc.</th>
                                        <th>Cliente</th>
                                        <th className="acao">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {lista.map(function (item, index) {
                                        return (
                                            <tr key={index}>
                                                <th>{item.numpedido}</th>
                                                <th>{FormataData(item.dtpedido)}</th>
                                                <th>{FormataDataHora(item.dtconclusao)}</th>
                                                <th>{FormataDataHora(item.dtprevisaoconclusao)}</th>
                                                <th>{item.cliente}</th>
                                                <th>
                                                    <div className="d-flex justify-content-center">
                                                        <button
                                                            type="button"
                                                            className="btn fa-regular fa-pen-to-square"
                                                            onClick={() => openModalEditar(item)}
                                                        ></button>
                                                        <button
                                                            type="button"
                                                            className="btn fa-solid fa-trash"
                                                            onClick={() => handleOpen(item)}
                                                        ></button>
                                                    </div>
                                                </th>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={6}>Quantidade de Registros: {lista.length}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpePedido;
